import { QueryClient } from "@tanstack/react-query";

// One shared QueryClient for the whole app. Defaults lean toward freshness
// over aggressive caching — this is a security dashboard, stale data is
// actively harmful. Adjust on a per-query basis when a specific view needs it.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (error instanceof Response && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});
